import { useEffect, useRef } from 'react';

import { CloseOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { createPortal } from 'react-dom';

import {
  Close,
  Content,
  Footer,
  InnerIcon,
  Message,
  OuterIcon,
  Overlay,
  PrimaryButton,
  Root,
  Title,
} from './styled';

import { useTheme } from '../../../hooks/useTheme';
import { Shell } from '../../atoms/Shell/Shell';

type Props = {
  open: boolean;
  onClose: () => void;
  onFinish?: () => void;
  title?: string;
  message?: string;
  loading?: boolean;
  warn?: string;
};

export default function ModalCompleteAccount({
  open,
  onClose,
  onFinish,
  title = 'CADASTRO DE CONTA CONCLUÍDO',
  message = 'Estamos revisando todas as informações do sua conta e, em até 1 dia útil, você receberá um e-mail de confirmação.',
  loading = false,
  warn,
}: Props) {
  const modalRef = useRef<HTMLDivElement>(null);
  const { theme } = useTheme();

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  useEffect(() => {
    if (open) modalRef.current?.focus();
  }, [open]);

  if (!open) return null;

  return createPortal(
    <Root
      aria-modal
      role='dialog'
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <Overlay />
      <Content ref={modalRef} tabIndex={-1}>
        <Close onClick={onClose} aria-label='Fechar'>
          <CloseOutlined />
        </Close>

        <OuterIcon isWarn={!!warn}>
          <InnerIcon isWarn={!!warn}>
            <CheckCircleOutlined style={{ color: '#fff', fontSize: 40 }} />
          </InnerIcon>
        </OuterIcon>

        {theme ? <Title>{title}</Title> : <Shell height={22} width={200} />}
        <Message>{message}</Message>

        {warn && <Message>{warn}</Message>}

        <Footer>
          {theme ? (
            <PrimaryButton
              type='button'
              onClick={() => {
                if (!loading) {
                  onClose();
                  onFinish?.();
                }
              }}
              disabled={loading}
            >
              {loading ? 'Enviando...' : 'Finalizar'}
            </PrimaryButton>
          ) : (
            <Shell height={22} width={200} />
          )}
        </Footer>
      </Content>
    </Root>,
    document.body,
  );
}
